import ddApi from "../api/dd-api";
import axios from "axios";

const findAll = () => {
  return ddApi.get("/recipe").then(response => response.data);
};

const findAllCategories = () => {
  return ddApi.get("/category").then(response => response.data);
};

const findAllTags = () => {
  return ddApi.get("/tag").then(response => response.data);
};

const findTagsByRecipeId = recipeId => {
  return ddApi.get(`/tag/${recipeId}`).then(response => {
    const mappedData = response.data.map(tag => {
      const { id, name } = tag.tag;
      return {
        id,
        name
      }
    })
    return mappedData;
  });
};

const findRelatedRecipesByRecipeId = recipeId => {
  return ddApi.get(`/recipe/related/items/${recipeId}`).then(response => {
    const relatedRecipes = response.data ? response.data : [];
    const mappedData = relatedRecipes.map(related => {
      const { id, name, image_url, category, category_key, key } = related;
      return {
        id,
        name,
        image_url,
        category,
        categoryKey: category_key,
        key
      }
    })
    return mappedData;
  });
}

const findByKeys = (categoryKey, key) => {
  return ddApi.get(`/recipe/${categoryKey}/${key}`).then(response => response.data);
};

const save = recipe => {
  return ddApi.post("/recipe", recipe);
};

const remove = id => {
  return ddApi.delete(`/recipe/${id}`);
};

const upload = data => {
  return axios.post("/api/recipe/upload", data);
};

export default {
  findByKeys,
  findAll,
  findAllCategories,
  findAllTags,
  findTagsByRecipeId,
  findRelatedRecipesByRecipeId,
  save,
  remove,
  upload
};
